<template>
    <div></div>
</template>
<script>
export default {
    data(){
        return {
            url:"",
            token:""
        }
    },
    created(){
        // this.url = location.href;
        // window.parent.wechatlogin(this.$route.query)
        let query = this.$route.query;
        localStorage.setItem("PUMU_WECHAT_LOGIN_MESSAGE",JSON.stringify(query))
        window.close();
    }
}
</script>